import React, { useState } from "react";

function Menu({ isOpen, onClose }) {
  const [isOpenDropdown, setIsOpenDropdown] = useState(null);

  const navigation = [
    {
      id: 1,
      label: "Our team",
      href: "/our-team",
    },
    {
      id: 2,
      label: "Our services",
      href: "#",
      dropdownNav: [
        {
          id: 1,
          label:
            "Diploma of Project Management for ESG Projects with Australia Certification",
          href: "/services/diploma-project-management-esg",
        },
        {
          id: 2,
          label: "Leadership in Sustainability",
          href: "/services/leadership-sustainability",
        },
        {
          id: 3,
          label: "ESG Workshop & Inhouse Training Topics",
          href: "/services/esg-workshop-training",
        },
        {
          id: 4,
          label: "CSR Workshop & Inhouse Training Topics",
          href: "/services/csr-workshop-training",
        },
        {
          id: 5,
          label: "Social Entrepreneurship Workshop & Inhouse Trainings",
          href: "/services/social-entrepreneurship-workshop-training",
        },
      ],
    },
    {
      id: 3,
      label: "Articles",
      href: "/articles",
    },
    {
      id: 4,
      label: "ISA consulting",
      href: "https://sustainability.co.id/",
      target: "_blank",
      rel: "noopener noreferrer",
    },
    {
      id: 5,
      label: "Contact us",
      href: "/contact-us",
    },
    {
      id: 6,
      label: "CCS Online Consultation",
      href: "/ccs-investment",
    },
    {
      id: 7,
      label: "Webinar",
      href: "/webinars",
    },
  ];

  const handleOpenDropdown = (e, navId, haveDropdown) => {
    if (haveDropdown) {
      e.preventDefault();
      if (isOpenDropdown) {
        setIsOpenDropdown(null);
      } else {
        setIsOpenDropdown(navId || null);
      }
    }
  };

  return (
    <div
      className={`lg:hidden fixed top-0 bottom-0 left-0 right-0 bg-white/50 backdrop-blur-lg ${
        isOpen ? "inline-block" : "hidden"
      } z-50`}
    >
      <div className="flex flex-col h-full gap-8 app-nav-container">
        <div className="text-base font-bold text-right">
          <button
            className="transition-all active:border-b-2 active:border-black"
            onClick={onClose}
          >
            Close
          </button>
        </div>
        <div className={`flex flex-col justify-between flex-1`}>
          <ul className="flex flex-col gap-4 text-base font-medium">
            {navigation &&
              navigation.map((nav, index) => {
                const navDropdown = nav && nav.dropdownNav;
                const navPath = nav && nav.href;
                const navLabel = nav && nav.label;
                const navId = nav && nav.id;
                const openDropdown = isOpenDropdown === navId;
                const haveDropdown = navDropdown && navDropdown.length > 0;
                if (
                  nav &&
                  (nav.label === "CCS Online Consultation" ||
                    nav.label === "Webinar")
                ) {
                  return (
                    <li key={nav?.id}>
                      <a
                        href={navPath}
                        onClick={(e) =>
                          handleOpenDropdown(e, navId, haveDropdown)
                        }
                        target={nav.target}
                        rel={nav.rel}
                        className={`inline-block px-4 py-2 text-xs font-semibold text-white uppercase transition rounded-md bg-${
                          nav.label === "CCS Online Consultation"
                            ? "[#0864FB]"
                            : "app-orange"
                        } sm:text-sm hover:opacity-90
                        `}
                      >
                        {navLabel}
                      </a>
                    </li>
                  );
                } else {
                  return (
                    <li className="app-animation-translate-start" key={index}>
                      <a
                        href={navPath}
                        onClick={(e) =>
                          handleOpenDropdown(e, navId, haveDropdown)
                        }
                        target={nav.target}
                        rel={nav.rel}
                      >
                        {navLabel}
                      </a>
                      {navDropdown &&
                        navDropdown.length > 0 &&
                        openDropdown && (
                          <ul className="flex flex-col px-4 py-4 space-y-4 font-medium">
                            {navDropdown &&
                              navDropdown.map((dropdown) => {
                                const dropdownPath = dropdown && dropdown.href;
                                const dropdownLabel =
                                  dropdown && dropdown.label;
                                return (
                                  <li>
                                    <a href={dropdownPath}>{dropdownLabel}</a>
                                  </li>
                                );
                              })}
                          </ul>
                        )}
                    </li>
                  );
                }
              })}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Menu;
